<template>
  <div class="upload-single-page-material">
    <div class="title">
      
      <div class="title-left">
        {{singlePage.elec_name}}
        <fliggy-select-file-btn
          v-if="!forbidUpload"
          class="m-l-20"
          :order="order"
          :applicant="applicant"
          :material-name="singlePage.elec_name"
          :max-select-num="1"
          :support-pdf="true"
          @confirm="onUploadByFliggy"
        ></fliggy-select-file-btn>
      </div>
      <div class="title-right">
        <!-- 在职证明在线生成，如果已经上传了，则隐藏提示 -->
        <on-job-online-btn
          class="m-l-20"
          :order="order"
          :applicant="applicant"
          :material="singlePage"
        ></on-job-online-btn>
      </div>
    </div>

    <div class="content">
      <div class="upload-box">

        <!-- 此处有可能是可选资料，但是用户没有上传，而且还没有操作需补充资料，就会出现一个空的upload数组的情况 -->
        <upload-item class="upload-item"
          :pdf="true"
          :img-url="singlePage.upload[0] && singlePage.upload[0].url"
          :upload="singlePage.upload[0] ? singlePage.upload[0] : {}"
          :forbid="forbidUpload"
          :verify-passed="singlePage.upload[0] && singlePage.upload[0].elec_status === consts.ELEC_STATUS.qualified_0"
          :verify-not-pass="singlePage.upload[0] && singlePage.upload[0].elec_status === consts.ELEC_STATUS.unqualified_3"
          :is-reupload="isReupload"
          @uploadFile="uploadSingle"
          :file-name="`${singlePage.elec_name}.pdf`"
          @reviewImage="reviewImage"></upload-item>

        <!-- 分割线 -->
        <div class="dashed-line" v-if="singlePage.sample || singlePage.attention"></div>

        <!-- 示例 -->
        <!-- 单页资料的样例虽然只有一张，但是返回的是一个数组 -->
        <sample class="sample-box" v-if="singlePage.sample && singlePage.sample.length > 0" :sample-url="singlePage.sample[0]" @click.native="reviewImage(singlePage.sample[0])"></sample>

        <!-- 注意事项 -->
        <attention class="attention-box" :class="{ 'no-sample-for-attention': !singlePage.sample }" :attention="singlePage.attention"></attention>
      </div>

      <!-- 资料不完善或需补充资料备注 有备注 且 不是暂不补充的时候显示在上面 -->
      <memo 
        class="memo" 
        v-if="singlePage.upload.length > 0 && singlePage.upload[0].memo && (!singlePage.refuseUpload || (singlePage.refuseUpload && !singlePage.refuseUpload.checked))"
        :memo-content="singlePage.upload[0].memo" 
        :memo-title="showRequireMaterialText ? '建议补充资料' : '预审不合格'"
        :invalid-file-list="singlePage.upload[0].invalid_file_set">
      </memo>

      <!-- 暂不补充 进来的时候会给资料一个 refuseUpload 对象 用于确定是否选中等 -->
      <div class="refuse-to-upload" v-if="singlePage.refuseUpload && showRefuseToUpload">
        <el-checkbox v-model="singlePage.refuseUpload.checked" @change="refuseToUploadChange($event, singlePage)">暂不补充</el-checkbox>
      </div>

      <!-- 资料不完善或需补充资料备注 有备注 且 是暂不补充的时候显示在下面 -->
      <memo 
        class="memo" 
        v-if="singlePage.upload.length > 0 && singlePage.upload[0].memo && singlePage.refuseUpload && singlePage.refuseUpload.checked"
        :memo-content="singlePage.upload[0].memo" 
        :memo-title="showRequireMaterialText ? '建议补充资料' : '预审不合格'"
        :invalid-file-list="singlePage.upload[0].invalid_file_set">
      </memo>
    </div>
  </div>
</template>

<script>
import uploadItem from './upload-item.vue';
import attention from './attention.vue';
import memo from './memo.vue';
import sample from './sample.vue';
import uploadFileService from '../../services/upload-file-service';
import uploadService from '../../services/upload-service';
import materialConstants from '../../constants/material-constants';
import applicantConstants from '../../constants/applicant-constants';
import FliggySelectFileBtn from './ota/fliggy-select-file-btn.vue';
import fileService from '../../services/file-service';
import OnJobOnlineBtn from './component/on-job-online-btn.vue';

export default {
  name: 'uploadSinglePageMaterial',
  components: {
    attention,
    uploadItem,
    memo,
    sample,
    FliggySelectFileBtn,
    OnJobOnlineBtn,
  },
  props: {
    singlePage: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    applicant: {
      type: Object,
      required: true,
      default() {
        return {};
      },
    },
    isOptional: {
      type: Boolean,
      required: true,
      default: false,
    },
    isReupload: {
      type: Boolean,
      default: false,
    },
    order: {
      type: Object,
      default() {
        return {};
      },
    },
  },
  data() {
    return {
      consts: {
        ELEC_STATUS: materialConstants.ELEC_STATUS,
      },
    };
  },
  computed: {

    // 是否禁用上传
    forbidUpload() {

      // 重新上传
      if (this.isReupload) {

        // 此处处理的是订单还未支付之前来到重新上传页面，需要可以修改和上传资料
        if (uploadService.isOrderStatusBeforePay(this.order.order_status)) {
          return false;
        }

        const isApplicantVerifyNotPass = this.applicant.applicant_status === applicantConstants.STATUS.verifyNotPassed_2;

        // 申请人不是资料不完善，都禁用
        if (!isApplicantVerifyNotPass) {
          return true;
        }

        // 一项都没有的时候需要禁用上传(出现在用户下单的时候没有上传资料，资料不完善的时候也没有需补充资料，但是此时需要展示，且不能上传)
        const isEmptyUpload = Boolean(!this.singlePage.upload[0].url);

        // 单页资料预审通过
        const isSinglePageVerifyPassed = this.singlePage.upload[0] && this.singlePage.upload[0].elec_status === materialConstants.ELEC_STATUS.qualified_0;
        const isSinglePageVerifyNotPass = this.singlePage.upload[0] && this.singlePage.upload[0].elec_status === materialConstants.ELEC_STATUS.unqualified_3;

        // 暂不上传
        const isMaterialSelectRefuseToUpload =
          this.singlePage.upload[0] &&
            this.singlePage.upload[0].elec_status === materialConstants.ELEC_STATUS.waittingForVerified_2 &&
              this.singlePage.upload[0].special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6;

        // 需补充资料
        const isMaterialNeededUpload =
          this.singlePage.upload[0] &&
            this.singlePage.upload[0].elec_status === materialConstants.ELEC_STATUS.waittingForUploadMaterial_1 &&
              this.singlePage.upload[0].special_code === materialConstants.SPECIAL_CODE.materialRequired_5;

        // 如果是需补充资料或者资料不完善，直接启用
        if (isMaterialNeededUpload || isSinglePageVerifyNotPass) {
          return false;
        }
        return isEmptyUpload || isSinglePageVerifyPassed || isMaterialSelectRefuseToUpload;
      }

      // 不是重新上传都不禁用
      return false;
    },

    // 是否显示暂不上传
    showRefuseToUpload() {
      // 申请人必需是资料不完善 且 资料一定是可选资料 才显示
      if (this.applicant.applicant_status !== applicantConstants.STATUS.verifyNotPassed_2 && this.isOptional) {
        return false;
      }

      // 没有图片不显示
      if (this.singlePage.upload.length === 0) {
        return false;
      }

      // 暂不上传一定只有一个upload项
      if (this.singlePage.upload.length === 1) {
        const upload = this.singlePage.upload[0];

        // 预审通过了不显示
        if (upload.elec_status === materialConstants.ELEC_STATUS.qualified_0) {
          return false;
        }

        // 已经是 用户选择了暂不上传 且 预审又不不合格，为了保证只能选择暂不上传一次
        if (upload.special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6
              && upload.elec_status === materialConstants.ELEC_STATUS.unqualified_3) {
          return false;
        }

        // 选了暂不上传 且 已经上传了图片 且 待预审
        if (upload.special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6
              && upload.elec_status === materialConstants.ELEC_STATUS.waittingForVerified_2
                && upload.url) {
          return false;
        }

        // 走到这里的时候只需要关注特殊状态就可以了
        return upload.special_code === materialConstants.SPECIAL_CODE.materialRequired_5
          || upload.special_code === materialConstants.SPECIAL_CODE.temporarilyNotUpload_6;
      }
    },

    // 是否显示需补充资料的字符
    showRequireMaterialText() {
      // 可选才有需补充资料
      if (this.isOptional) {
        if (this.singlePage && this.singlePage.upload && this.singlePage.upload.length === 1
          && this.singlePage.upload[0].special_code === materialConstants.SPECIAL_CODE.materialRequired_5) {
          return true;
        }
      }

      return false;
    },
  },
  methods: {

    // 上传单页资料
    uploadSingle(file) {
      this.singlePage.upload[0].file = file;
      this.singlePage.upload[0].url = URL.createObjectURL(file);

      // 设置loading状态
      this.$set(this.singlePage.upload[0], 'loading', true);

      // uploadFile  // 已经改了
      uploadFileService.uploadFile(file, false, { noKey: true }).then((res) => {
        this.photoKeyUploadSinglePage(res);
      }).catch((e) => {
        if (e) console.log(e);
      });
    },
    // 飞猪资料上传
    onUploadByFliggy({ key_list }) {
      const key = key_list[0];
      // 设置loading状态
      this.$set(this.singlePage.upload[0], 'loading', true);
      this.singlePage.upload[0].url = fileService.getOssFullUrl(key);
      this.photoKeyUploadSinglePage(key);
    },
    // 照片KEY上传到单页上
    photoKeyUploadSinglePage(key) {
      const dowloadName = `${this.applicant.applicant_name}${this.singlePage.elec_name}.pdf`;
      uploadFileService.doUpload(this.singlePage, this.singlePage.upload[0], this.applicant.user_order_id, this.applicant.order_applicant_id, key, dowloadName).then(() => {
        // 重新上传
        if (this.isReupload) {
          this.singlePage.upload[0].memo = '';
          this.singlePage.upload[0].elec_status = materialConstants.ELEC_STATUS.waittingForVerified_2;
          this.singlePage.upload[0].special_code = 0;
        }
      }).catch(() => {
        // 感觉timeout一下没有那么突兀
        setTimeout(() => {
          this.singlePage.upload[0].url = '';
        }, 1000);
      });
    },

    // 暂不上传切换
    refuseToUploadChange(event, material) {
      const checked = event.target.checked;

      // 抛出事件外面统一处理
      this.$emit('refuseUploadChange', checked, material);
    },

    // 预览图片
    reviewImage(imageSrc) {
      this.$emit('reviewImage', imageSrc);
    },
  },
};
</script>

<style lang="less" scoped>
@import '../../assets/less/variable';
.upload-single-page-material {
  line-height: 1;
  background-color: #fff;
  .title {
    padding: 30px 30px 20px 30px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    .title-left{
      display: flex;
      align-items: center;
    }
    .title-right{
      display: flex;
      align-items: center;
    }
  }
  .content {
    padding: 0 30px 30px 30px;
    .upload-box {
      display: flex;
      .upload-item {
        width: 200px;
        height: 130px;
      }
      .dashed-line {
        width: 1px;
        height: 130px;
        background-color: white;
        border-right: 1px dashed @border;
        margin-left: 50px;
      }
      .sample-box {
        margin-left: 50px;
        height: 130px;
      }
      .attention-box {
        margin-left: 30px;
        flex: 1;
        &.no-sample-for-attention {
          margin-left: 50px;
        }
      }
    }
    .memo {
      margin-top: 20px;
    }
    .refuse-to-upload {
      margin-top: 20px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/upload/upload-single-page-material.vue